angular.module('aprima-core', [
    'lodash', 
]);
